/* Built In Imports */
import React from 'react';

/* External Imports */
import { Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import TopBannerEvent from '@moms/Banner/TopBannerEvent';
import TopBannerV2 from '@moms/Banner/TopBannerV2';
import TopBannerVideo from '@moms/Banner/TopBannerVideo';
import MiracleOfMindBlogTabGroup from '@moms/Cards/MiracleOfMindBlogTabGroup';
import SectionTitle from '@moms/Headings/SectionTitle';
import Quote from '@moms/Ui/Sections/Quote';

/* Styles */
/* Services */

/**
 * @param {Object} section
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const SectionCommonUi = ({ sectionContent, region, lang, section }) => {
  return (
    <Flex w="100%" flexDirection="column">
      {RenderComponents({
        sectionContent,
        region,
        lang,
        section,
      })}
    </Flex>
  );
};
const RenderComponents = ({ sectionContent, region, lang, section }) => {
  const { _modelApiKey } = sectionContent;
  switch (_modelApiKey) {
    case 'top_banner_event':
      return (
        <TopBannerEvent
          sectionContent={sectionContent}
          region={region}
          lang={lang}
        />
      );
    case 'top_banner_video':
      return (
        <TopBannerVideo
          sectionContent={sectionContent}
          region={region}
          lang={lang}
        />
      );
    case 'section_title':
      return (
        <SectionTitle
          sectionContent={sectionContent}
          region={region}
          lang={lang}
        />
      );
    case 'miracle_of_mind_blog_tab_group':
      return (
        <MiracleOfMindBlogTabGroup
          sectionContent={sectionContent}
          region={region}
          lang={lang}
        />
      );
    case 'top_banner_v2':
      return (
        <TopBannerV2
          sectionContent={sectionContent}
          region={region}
          lang={lang}
          sectionId={section?.sectionId}
        />
      );
    case 'quote':
      return (
        <Quote sectionContent={sectionContent} region={region} lang={lang} />
      );
  }
};
export default SectionCommonUi;
